import React from 'react';
import { logFrontendError } from '../services/api';
import '../styles/error-boundary.css';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        // Catch errors in any components below and re-render with error message
        console.error("ErrorBoundary caught an error", error, errorInfo);

        // Extract context data from localStorage if available
        const orgId = localStorage.getItem('org_id') || "";
        const username = localStorage.getItem('username') || "";
        // You could also extract lead_id or session_id if stored globally

        logFrontendError({
            org_id: orgId,
            username: username,
            error_message: error.message || "React Rendering Error",
            stack_trace: error.stack || "",
            additional_info: { errorInfo }
        });
    }

    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return (
                <div className="error-boundary-container">
                    <h2>Something went wrong.</h2>
                    <p>We have logged the issue and are looking into it.</p>
                    <button 
                        onClick={() => window.location.reload()}
                        className="error-boundary-reload-btn"
                    >
                        Reload Page
                    </button>
                </div>
            );
        }

        return this.props.children; 
    }
}

export default ErrorBoundary;
